<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <section>
    <div class="row">
      <div class="col-sm-6">
        <requested-call-overview></requested-call-overview>
        <basic-details :hide-security-details="true"></basic-details>
        <additional-visitors :show-add-btn="false"></additional-visitors>
        <visitor-bans :visitor_user_id="call.visitor.user_id"></visitor-bans>
      </div>
      <div class="col-sm-6">
        <visitor-details :visitor_user_id="call.visitor.user_id"></visitor-details>
        <visitors-previous-visits :visitor_user_id="call.visitor.user_id"
                                  :prisoner_number="call.prisoner.prisoner_number"></visitors-previous-visits>
      </div>
    </div>
  </section>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import BasicDetails from '@/views/calls/callDetails/sections/BasicDetails.vue';
import AdditionalVisitors from '@/views/calls/callDetails/sections/AdditionalVisitors';
import VisitorDetails from '@/components/visitors/details/VisitorDetails';
import RequestedCallOverview from '@/views/calls/callDetails/sections/requested/RequestedCallOverview';
import VisitorBans from '@/views/bans/VisitorBans';
import VisitorsPreviousVisits from '@/views/visitorDetails/VisitorsPreviousVisits';

export default {
  name: 'CallDetailsRequested',
  components: {
    BasicDetails,
    AdditionalVisitors,
    VisitorDetails,
    RequestedCallOverview,
    VisitorBans,
    VisitorsPreviousVisits,
  },
  props: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitors: state => state.callDetails.additionalVisitors,
    }),
  },
  mounted() {

  },
  methods: {

  },
}
</script>
